var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('add-header',{ref:"pageHeader"}),(_vm.loading)?_c('Loading'):_vm._e(),_c('div',{staticClass:"content"},[_c('PageHeader')],1),_c('add-footer',{staticClass:"mobileHide"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }